module.exports = __webpack_public_path__ + "img/ruiyan_07.9985086b.jpg";